import { useLayoutEffect, useState } from "react";
import { isBrowser } from "../isBrowser";

const defaultConfig = {
  childList: true,
};

let animationFrameID = 0;
export const useMutationObserver = (
  element: HTMLElement | Document | null,
  config: MutationObserverInit = defaultConfig,
): MutationRecord | undefined => {
  const [entry, setEntry] = useState<MutationRecord>();
  useLayoutEffect(() => {
    if (!isBrowser) return;
    const mutationObserver = new MutationObserver((entries) => {
      if (!Array.isArray(entries)) {
        return;
      }
      if (!entries.length) {
        return;
      }
      animationFrameID = window.requestAnimationFrame(() => {
        setEntry(entries[0]);
      });
    });
    if (element) {
      mutationObserver.observe(element, config);
    }
    return () => {
      if (element) {
        mutationObserver.disconnect();
      }
      window.cancelAnimationFrame(animationFrameID);
    };
  }, [config, element]);
  return entry;
};
